import {
  convertBooleanToStringLiteral,
  convertToType,
  preserveEmpty,
} from '~/core/application/workflow/utils/transformFuncs';
import { FieldToBlock } from '~/core/shared/fields/declarations';
import { commonFieldBlockProps } from '~/core/shared/fields/FieldUtils';
import { WorkflowStepFormFieldBoolean } from '~/core/shared/types';
import { getBooleanFieldLabels } from './getBooleanFieldLabels';

export const booleanFieldToBlock: FieldToBlock<
  'boolean',
  WorkflowStepFormFieldBoolean
> = (field) => {
  const { truthyLabel, falsyLabel } = getBooleanFieldLabels(field.meta?.labels);

  return {
    ...commonFieldBlockProps(field),
    componentProps: {
      options: [
        {
          label: truthyLabel,
          value: 'true',
        },
        {
          label: falsyLabel,
          value: 'false',
        },
      ],
    },
    transformFuncsIn: [convertBooleanToStringLiteral],
    transformFuncsOut: [preserveEmpty(convertToType('boolean'))],
    componentType: 'select',
  };
};
